import { writable } from 'svelte/store';

export const BasketStore = writable();
